import React, { useEffect } from 'react'
import { useLocation } from 'react-router'
import { useScrollToAnchor } from '../../hooks/useScrollToAnchor'

export const ToTopOnRoute = () => {

    useScrollToAnchor()

    return <></>
}